var React = require('react');

function EvzerLogoNavLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M70.9,47.9h46.6V0H72.7c-1.1,0-2.2,0.4-3.1,1.2L1.5,62.4c-1.9,1.7-2,4.6-0.3,6.5c0.1,0.1,0.2,0.2,0.3,0.3L69.6,132\n\tc0.9,0.8,2,1.2,3.1,1.2H118V85.3H70.9V47.9z","key":0}),React.createElement("rect",{"id":"spacer","x":"70.7","y":"52.3","width":"50.8","height":"28.4","key":1})]);
}

EvzerLogoNavLeftInline.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 121.5 133.2","style":{"enableBackground":"new 0 0 121.5 133.2"},"xmlSpace":"preserve","preserveAspectRatio":"none"};

module.exports = EvzerLogoNavLeftInline;

EvzerLogoNavLeftInline.default = EvzerLogoNavLeftInline;
